<template>
  <section class="c-section c-section--services">
    <div class="container">
      <div class="c-banner-top d-flex flex-column
          justify-content-center px-5 py-3 mt-0">
          <h2 class="fs-35 w-sbold gray-lightx mb-3 mb-md-5">
            Servicios
          </h2>
          <div class="c-banner-top__text">
            <router-link to="/" class="c-link gray-light">
              Inicio
            </router-link>
            <span>
              /
            </span>
            <router-link to="/servicios" class="c-link gray-light">
              Servicios
            </router-link>
          </div>
        <div
          class="c-banner-top__container d-none d-md-block"
          :style="`background-image:url(${context.banner_image})`"
          >
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12 col-lg-7">
          <div class="c-serviceslist">
            <h1 class="c-serviceslist__title fs-50 w-light sec-medium text-center mb-4">
              {{context.titulo}}
            </h1>
            <p class="c-serviceslist__description text-center sec-medium">
              {{context.descripcion}}
            </p>
          </div>
        </div>
      </div>
      <ul v-if="context.services" class="row ul-reset gy-5 gx-5 mb-5 pb-5">
        <li v-for="(service,i) of context.services" :key="`service-${i}`" class="col-12 col-lg-4">
          <div class="c-service">
            <figure class="c-service__figure">
              <img
                v-if="service.thumbnail"
                :src="service.thumbnail"
                class="h-100 w-100 of--cover" alt="">
            </figure>
            <div class="c-service__content">
              <div>
                <h3 class="c-service__title">{{service.post_title}}</h3>
                <p v-if="service.except" class="c-service__resume">
                  {{service.except}}
                </p>
              </div>
              <RouterLink :to="`/servicio/${service.post_name}`"
                class="c-button c-button--white-ghost">
                Ver más
              </RouterLink>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      context: {},
      contextLoading: true,
      services: [],
    };
  },
  created() {
    this.getFullContext({ type: 'page', slug: 'servicios' });
  },
};
</script>
